import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "col-sm-12" }
const _hoisted_2 = { class: "card card-body mb-0" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "form-group col-sm-12" }
const _hoisted_5 = { class: "navbar-nav overflow-auto flex-row gap-4" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_9 = { class: "col p-0" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_13 = { class: "col p-0" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = {
  key: 1,
  class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"
}
const _hoisted_16 = { class: "col p-0" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = {
  key: 2,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_19 = { class: "col p-0" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = {
  key: 3,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_22 = { class: "col p-0" }
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = {
  key: 0,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_26 = { class: "col p-0" }
const _hoisted_27 = { class: "" }
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = {
  key: 1,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_30 = { class: "col p-0" }
const _hoisted_31 = { class: "" }
const _hoisted_32 = ["placeholder"]
const _hoisted_33 = {
  key: 2,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_34 = { class: "col p-0" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_37 = { value: "active" }
const _hoisted_38 = { value: "inactive" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = {
  key: 0,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2 d-flex align-items-center"
}
const _hoisted_41 = { class: "col p-0" }
const _hoisted_42 = { class: "navbar-nav overflow-auto flex-row gap-2" }
const _hoisted_43 = { class: "nav-item nav-item-spaced d-lg-block text-nowrap" }
const _hoisted_44 = { class: "nav-item nav-item-spaced d-lg-block text-nowrap" }
const _hoisted_45 = { class: "nav-item nav-item-spaced d-lg-block text-nowrap" }
const _hoisted_46 = { class: "form-group mb-2 col" }
const _hoisted_47 = { class: "col-auto p-0 text-end" }
const _hoisted_48 = { class: "col-sm-12" }
const _hoisted_49 = { class: "card card-body" }
const _hoisted_50 = {
  key: 0,
  class: "row"
}
const _hoisted_51 = { class: "col-sm-12" }
const _hoisted_52 = { class: "col-sm-12" }
const _hoisted_53 = { class: "overflow-auto" }
const _hoisted_54 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_55 = {
  class: "text-capitalize-first",
  style: {"width":"0"}
}
const _hoisted_56 = {
  class: "text-capitalize-first",
  style: {"width":"0"}
}
const _hoisted_57 = {
  key: 0,
  class: "text-capitalize-first"
}
const _hoisted_58 = { class: "text-capitalize-first" }
const _hoisted_59 = {
  key: 1,
  class: "text-capitalize-first"
}
const _hoisted_60 = { class: "text-capitalize-first" }
const _hoisted_61 = { class: "text-end" }
const _hoisted_62 = { class: "text-center" }
const _hoisted_63 = ["title"]
const _hoisted_64 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_65 = ["title"]
const _hoisted_66 = ["disabled", "onClick", "checked"]
const _hoisted_67 = ["title"]
const _hoisted_68 = ["disabled", "onClick", "checked"]
const _hoisted_69 = { class: "text-center" }
const _hoisted_70 = {
  key: 0,
  class: "d-inline-block"
}
const _hoisted_71 = ["disabled", "title", "onClick"]
const _hoisted_72 = ["disabled", "title", "onClick"]
const _hoisted_73 = {
  key: 1,
  class: "d-inline-block"
}
const _hoisted_74 = ["title"]
const _hoisted_75 = ["title"]
const _hoisted_76 = { class: "text-center" }
const _hoisted_77 = {
  key: 0,
  class: "d-inline-block"
}
const _hoisted_78 = ["disabled", "title", "onClick"]
const _hoisted_79 = ["disabled", "title", "onClick"]
const _hoisted_80 = {
  key: 1,
  class: "d-inline-block"
}
const _hoisted_81 = ["title"]
const _hoisted_82 = ["title"]
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "d-flex flex-column" }
const _hoisted_85 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_86 = { key: 1 }
const _hoisted_87 = { class: "text-primary" }
const _hoisted_88 = { key: 2 }
const _hoisted_89 = { class: "text-primary" }
const _hoisted_90 = { key: 3 }
const _hoisted_91 = {
  class: "text-secondary",
  style: {"white-space":"normal"}
}
const _hoisted_92 = { key: 1 }
const _hoisted_93 = {
  key: 0,
  class: "d-flex mb-1 align-items-center"
}
const _hoisted_94 = {
  key: 0,
  class: "fa fa-eye-slash ms-2"
}
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "col-sm-12 d-flex align-items-center justify-content-between" }
const _hoisted_97 = { class: "d-flex align-items-center" }
const _hoisted_98 = {
  key: 0,
  class: "me-2 text-secondary"
}
const _hoisted_99 = ["title"]
const _hoisted_100 = ["onClick"]
const _hoisted_101 = ["onClick"]
const _hoisted_102 = { class: "text-end" }
const _hoisted_103 = {
  key: 0,
  class: "btn-group"
}
const _hoisted_104 = ["onClick"]
const _hoisted_105 = {
  type: "button",
  class: "btn btn-sm btn-outline-dark dropdown-toggle dropdown-toggle-split",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_106 = { class: "dropdown-menu" }
const _hoisted_107 = { key: 0 }
const _hoisted_108 = ["onClick"]
const _hoisted_109 = { key: 1 }
const _hoisted_110 = ["onClick"]
const _hoisted_111 = ["onClick"]
const _hoisted_112 = ["onClick"]
const _hoisted_113 = { key: 2 }
const _hoisted_114 = ["onClick"]
const _hoisted_115 = {
  key: 1,
  class: "btn-group"
}
const _hoisted_116 = ["onClick"]
const _hoisted_117 = ["onClick"]
const _hoisted_118 = ["onClick"]
const _hoisted_119 = ["onClick"]
const _hoisted_120 = {
  key: 0,
  class: "fa fa-eye"
}
const _hoisted_121 = {
  key: 1,
  class: "fa fa-pencil"
}
const _hoisted_122 = { class: "row mb-3 mt-3" }
const _hoisted_123 = { class: "col-sm-12" }
const _hoisted_124 = { class: "p-0 m-0" }
const _hoisted_125 = { key: 0 }
const _hoisted_126 = { class: "col-sm-12" }
const _hoisted_127 = { class: "me-2" }
const _hoisted_128 = ["disabled"]
const _hoisted_129 = { class: "row mb-2" }
const _hoisted_130 = { class: "col-sm-12" }
const _hoisted_131 = { class: "row mt-2" }
const _hoisted_132 = {
  for: "from_sum",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_133 = { class: "col-sm-8" }
const _hoisted_134 = ["readonly"]
const _hoisted_135 = { class: "row mt-2" }
const _hoisted_136 = {
  for: "to_sum",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_137 = { class: "col-sm-8" }
const _hoisted_138 = ["readonly"]
const _hoisted_139 = { class: "row mt-2" }
const _hoisted_140 = {
  for: "pay-out-currencies",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_141 = { class: "col-sm-8" }
const _hoisted_142 = { class: "row mt-2" }
const _hoisted_143 = {
  class: "col-sm-4 col-form-label text-capitalize-first",
  for: "pay-out-roundedToTakerSum"
}
const _hoisted_144 = { class: "col-sm-8" }
const _hoisted_145 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_146 = ["disabled"]
const _hoisted_147 = { class: "row mt-2" }
const _hoisted_148 = {
  for: "pay-out-methods",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_149 = { class: "col-sm-8" }
const _hoisted_150 = { class: "d-flex flex-row align-items-center gap-2" }
const _hoisted_151 = {
  class: "overflow-hidden",
  style: {"white-space":"nowrap","text-overflow":"ellipsis"}
}
const _hoisted_152 = { class: "row mt-2" }
const _hoisted_153 = {
  for: "pay-out-options",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_154 = { class: "col-sm-8" }
const _hoisted_155 = { class: "row mt-2" }
const _hoisted_156 = {
  for: "pay-out-onlyMir",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_157 = { class: "col-sm-8" }
const _hoisted_158 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_159 = ["disabled"]
const _hoisted_160 = { class: "row mt-2" }
const _hoisted_161 = {
  for: "maxActiveDealCount",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_162 = { class: "col-sm-8" }
const _hoisted_163 = { class: "col-sm-8" }
const _hoisted_164 = ["readonly"]
const _hoisted_165 = { class: "row mt-2" }
const _hoisted_166 = {
  for: "limitAmount",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_167 = { class: "col-sm-8" }
const _hoisted_168 = { class: "col-sm-8" }
const _hoisted_169 = ["readonly"]
const _hoisted_170 = { class: "row mt-2" }
const _hoisted_171 = {
  for: "limitIntervalMinutes",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_172 = { class: "col-sm-8" }
const _hoisted_173 = { class: "col-sm-8" }
const _hoisted_174 = ["readonly"]
const _hoisted_175 = { class: "row mt-2" }
const _hoisted_176 = {
  class: "col-sm-4 col-form-label text-capitalize-first",
  for: "auto_accept_payouts"
}
const _hoisted_177 = { class: "col-sm-8" }
const _hoisted_178 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_179 = ["disabled"]
const _hoisted_180 = {
  key: 0,
  class: "my-3"
}
const _hoisted_181 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TeamLeadMultiselect = _resolveComponent("TeamLeadMultiselect")!
  const _component_TrafficGroupMultiselect = _resolveComponent("TrafficGroupMultiselect")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TraderForm = _resolveComponent("TraderForm")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_AccountWidget = _resolveComponent("AccountWidget")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_InviteLinkConfirmModal = _resolveComponent("InviteLinkConfirmModal")!
  const _component_TransferForm = _resolveComponent("TransferForm")!
  const _component_TraderRewardSettingsForm = _resolveComponent("TraderRewardSettingsForm")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_PayinBalanceLimitSection = _resolveComponent("PayinBalanceLimitSection")!
  const _component_AccountOperationsModal = _resolveComponent("AccountOperationsModal")!
  const _component_AccountWalletModal = _resolveComponent("AccountWalletModal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_ChangePasswordModal = _resolveComponent("ChangePasswordModal")!
  const _component_SettingsHistoryModal = _resolveComponent("SettingsHistoryModal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!
  const _directive_bs_dropdown_fixed = _resolveDirective("bs-dropdown-fixed")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Tabs, (value, tab) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: tab,
                    class: "nav-item nav-item-spaced d-lg-block text-nowrap"
                  }, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _withModifiers(($event: any) => (_ctx.selectTab(tab)), ["prevent"]),
                      class: _normalizeClass(["nav-link tab", {'active': _ctx.activeTabName === tab}])
                    }, _toDisplayString(_ctx.helper.trans(`traders.tab.${tab}`)), 11, _hoisted_6)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    onKeydown: _cache[0] || (_cache[0] = _withKeys(() => _ctx.applyFilters(), ["enter"])),
                    placeholder: _ctx.helper.trans('labels.name'),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.query) = $event))
                  }, null, 40, _hoisted_11), [
                    [_vModelText, _ctx.requestDTO.query]
                  ])
                ])
              ])
            ]),
            (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_TeamLeadMultiselect, {
                        multiple: true,
                        modelValue: _ctx.teamLeadsFilter,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.teamLeadsFilter) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAdmin || _ctx.isOperator)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_TrafficGroupMultiselect, {
                        multiple: true,
                        small: "",
                        modelValue: _ctx.trafficGroupsFilter,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.trafficGroupsFilter) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            ((_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead) && _ctx.activeTabName !== 'all')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_Multiselect, {
                        id: "blockReasons",
                        class: "multiselect-sm",
                        modelValue: _ctx.requestDTO.blockReasons,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.blockReasons) = $event)),
                        options: Object.values(_ctx.BlockReason),
                        "custom-label": (opt) => _ctx.helper.trans(`block_reason.${opt}`),
                        multiple: true,
                        "select-label": "Select",
                        placeholder: _ctx.helper.trans('block_reason.label')
                      }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            ((_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead) && _ctx.activeTabName === 'all')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_Multiselect, {
                        id: "blockReasons",
                        class: "multiselect-sm",
                        modelValue: _ctx.requestDTO.excludedBlockReasons,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestDTO.excludedBlockReasons) = $event)),
                        options: Object.values(_ctx.BlockReason),
                        "custom-label": (opt) => _ctx.helper.trans(`block_reason.${opt}`),
                        multiple: true,
                        "select-label": "Select",
                        placeholder: _ctx.helper.trans('labels.excluded_block_reason')
                      }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        placeholder: _ctx.helper.trans('labels.from_sum_balance'),
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestDTO.minBalanceAmount) = $event))
                      }, null, 8, _hoisted_28), [
                        [_vModelText, _ctx.requestDTO.minBalanceAmount]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-sm",
                        placeholder: _ctx.helper.trans('labels.to_sum_balance'),
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestDTO.maxBalanceAmount) = $event))
                      }, null, 8, _hoisted_32), [
                        [_vModelText, _ctx.requestDTO.maxBalanceAmount]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestDTO.hasRequisitesPlan) = $event))
                      }, [
                        _createElementVNode("option", _hoisted_36, _toDisplayString(_ctx.helper.trans('filters.plan_status.placeholder')), 1),
                        _createElementVNode("option", _hoisted_37, _toDisplayString(_ctx.helper.trans('filters.plan_status.enabled')), 1),
                        _createElementVNode("option", _hoisted_38, _toDisplayString(_ctx.helper.trans('filters.plan_status.disabled')), 1)
                      ], 512), [
                        [_vModelSelect, _ctx.requestDTO.hasRequisitesPlan]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_39, [
            ((_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead) && _ctx.activeTabName === 'active')
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("ul", _hoisted_42, [
                      _createElementVNode("li", _hoisted_43, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => {_ctx.requestDTO.activeType = 'in'; _ctx.loadList()}, ["prevent"])),
                          class: _normalizeClass([{'active': _ctx.requestDTO.activeType === 'in'}, "nav-link tab"])
                        }, _toDisplayString(_ctx.helper.trans('labels.pay_in')), 3)
                      ]),
                      _createElementVNode("li", _hoisted_44, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => {_ctx.requestDTO.activeType = 'out';_ctx.loadList()}, ["prevent"])),
                          class: _normalizeClass([{'active': _ctx.requestDTO.activeType === 'out'}, "nav-link tab"])
                        }, _toDisplayString(_ctx.helper.trans('labels.pay_out')), 3)
                      ]),
                      _createElementVNode("li", _hoisted_45, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => {_ctx.requestDTO.activeType = null; _ctx.loadList()}, ["prevent"])),
                          class: _normalizeClass([{'active': _ctx.requestDTO.activeType === null}, "nav-link tab text-capitalize"])
                        }, _toDisplayString(_ctx.helper.trans('labels.all')), 3)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[12] || (_cache[12] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                  class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[13] || (_cache[13] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                  class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          (_ctx.isTeamLead)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.downloadTradersRate(_ctx.user?.id)), ["prevent"])),
                    class: "btn btn-link btn-sm m-0 p-0 text-capitalize-first float-end"
                  }, [
                    _cache[52] || (_cache[52] = _createElementVNode("i", { class: "fa fa-file-export" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.download_traders_percent_rates')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => {_ctx.ratesImportModal = true; _ctx.importFile = null}, ["prevent"])),
                    class: "btn btn-link btn-sm m-0 p-0 text-capitalize-first float-end"
                  }, [
                    _cache[53] || (_cache[53] = _createElementVNode("i", { class: "fa fa-file-import" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.import_traders_percent_rates')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("table", _hoisted_54, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _cache[54] || (_cache[54] = _createElementVNode("td", null, null, -1)),
                  _createElementVNode("th", _hoisted_55, _toDisplayString(_ctx.helper.trans('direction.in')), 1),
                  _createElementVNode("th", _hoisted_56, _toDisplayString(_ctx.helper.trans('direction.out')), 1),
                  (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_57, [
                        _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.id')) + " ", 1),
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.orderByDTO, 'id'); _ctx.loadList()}, ["prevent"]))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderByDTO, 'id')])
                          }, null, 2)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("th", _hoisted_58, _toDisplayString(_ctx.helper.trans('labels.name')), 1),
                  (_ctx.isAdmin || _ctx.isOperator)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_59, _toDisplayString(_ctx.helper.trans('labels.teamlead')), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("th", _hoisted_60, [
                    _createTextVNode(_toDisplayString(_ctx.helper.trans('labels.balances')) + " ", 1),
                    (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "#",
                          onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => {_ctx.helper.toggleOrderBy(_ctx.orderByDTO, 'balance'); _ctx.loadList()}, ["prevent"]))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["fa-solid", _ctx.helper.orderByClass(_ctx.orderByDTO, 'balance')])
                          }, null, 2)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("th", _hoisted_61, [
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showEditModal({}))),
                          class: "btn btn-outline-primary btn-sm text-capitalize"
                        }, _toDisplayString(_ctx.helper.trans('button.create')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isAdmin || _ctx.isOperator)
                      ? (_openBlock(), _createBlock(_component_b_modal, {
                          key: 1,
                          "dialog-class": "modal-lg",
                          title: _ctx.createModalTitle,
                          modelValue: _ctx.createModal,
                          "body-class": "pt-0",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.createModal = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_TraderForm, {
                              ref: "createForm",
                              onUpdated: _ctx.onTraderUpdated
                            }, null, 8, ["onUpdated"])
                          ]),
                          footer: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.createModal = false)),
                              class: "btn btn-outline-secondary btn-sm text-capitalize-first"
                            }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
                            _createVNode(_component_LoaderWrapper, {
                              ref: "loaderCreateFrom",
                              zoom: 0.5
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.save())),
                                  class: "btn btn-outline-primary btn-sm text-capitalize-first"
                                }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        }, 8, ["title", "modelValue"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (trader) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: trader.id,
                    class: ""
                  }, [
                    _createElementVNode("td", _hoisted_62, [
                      (trader.isBlocked)
                        ? _withDirectives((_openBlock(), _createElementBlock("i", {
                            key: 0,
                            title: _ctx.helper.trans('labels.user_blocked'),
                            class: "fa fa-ban text-danger"
                          }, null, 8, _hoisted_63)), [
                            [
                              _directive_b_tooltip,
                              void 0,
                              void 0,
                              { hover: true }
                            ]
                          ])
                        : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _withDirectives((_openBlock(), _createElementBlock("small", {
                              class: "form-switch",
                              title: `${_ctx.helper.trans('direction.in')}: ${_ctx.helper.trans(trader.isActive ? 'trader.status.active' : 'trader.status.inactive')}`
                            }, [
                              _createElementVNode("input", {
                                id: "traderStatus",
                                disabled: _ctx.isTeamLead && !_ctx.store.getters.hasPermission(_ctx.UserPermission.MANAGE_TRADER_TRAFFIC),
                                onClick: _withModifiers(($event: any) => (_ctx.toggleStatus(trader, !trader.isActive, _ctx.Direction.PAY_IN)), ["prevent"]),
                                class: "form-check-input",
                                style: {"cursor":"pointer"},
                                type: "checkbox",
                                role: "switch",
                                checked: trader.isActive
                              }, null, 8, _hoisted_66)
                            ], 8, _hoisted_65)), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                {
                                  hover: true,
                                  left: true
                                }
                              ]
                            ]),
                            _withDirectives((_openBlock(), _createElementBlock("small", {
                              class: "form-switch",
                              title: `${_ctx.helper.trans('direction.out')}: ${_ctx.helper.trans(trader.isPayOutActive ? 'trader.status.active' : 'trader.status.inactive')}`
                            }, [
                              _createElementVNode("input", {
                                id: "traderStatus",
                                disabled: _ctx.isTeamLead && !_ctx.store.getters.hasPermission(_ctx.UserPermission.MANAGE_TRADER_TRAFFIC),
                                onClick: _withModifiers(($event: any) => (_ctx.toggleStatus(trader, !trader.isPayOutActive, _ctx.Direction.PAY_OUT)), ["prevent"]),
                                class: "form-check-input",
                                style: {"cursor":"pointer"},
                                type: "checkbox",
                                role: "switch",
                                checked: trader.isPayOutActive
                              }, null, 8, _hoisted_68)
                            ], 8, _hoisted_67)), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                {
                                  hover: true,
                                  left: true
                                }
                              ]
                            ])
                          ]))
                    ]),
                    _createElementVNode("td", _hoisted_69, [
                      ((_ctx.isAdmin || _ctx.isOperator))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                            (!trader.isPayInTrafficBlocked)
                              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  disabled: trader.isBlocked,
                                  title: _ctx.helper.trans('trader.status.active'),
                                  onClick: _withModifiers(($event: any) => (_ctx.toggleTraffic(trader, _ctx.Direction.PAY_IN, false)), ["prevent"]),
                                  class: "ms-2 btn-sm btn btn-outline-success"
                                }, _cache[55] || (_cache[55] = [
                                  _createElementVNode("i", { class: "fa fa-circle-play" }, null, -1)
                                ]), 8, _hoisted_71)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                              : _withDirectives((_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  disabled: trader.isBlocked,
                                  title: _ctx.helper.trans('labels.traffic_blocked'),
                                  onClick: _withModifiers(($event: any) => (_ctx.toggleTraffic(trader, _ctx.Direction.PAY_IN, true)), ["prevent"]),
                                  class: "ms-2 btn btn-sm btn-outline-warning"
                                }, _cache[56] || (_cache[56] = [
                                  _createElementVNode("i", { class: "fa fa-circle-pause" }, null, -1)
                                ]), 8, _hoisted_72)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            (trader.isPayInTrafficBlocked)
                              ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  title: _ctx.helper.trans('labels.traffic_blocked'),
                                  class: "fa fa-circle-pause text-warning"
                                }, null, 8, _hoisted_74)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                              : _withDirectives((_openBlock(), _createElementBlock("i", {
                                  key: 1,
                                  title: _ctx.helper.trans('trader.status.active'),
                                  class: "fa fa-circle-play text-success"
                                }, null, 8, _hoisted_75)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                          ]))
                    ]),
                    _createElementVNode("td", _hoisted_76, [
                      ((_ctx.isAdmin || _ctx.isOperator))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            (!trader.isPayOutTrafficBlocked)
                              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  disabled: trader.isBlocked,
                                  title: _ctx.helper.trans('trader.status.active'),
                                  onClick: _withModifiers(($event: any) => (_ctx.toggleTraffic(trader, _ctx.Direction.PAY_OUT, false)), ["prevent"]),
                                  class: "ms-2 btn btn-sm btn-outline-success"
                                }, _cache[57] || (_cache[57] = [
                                  _createElementVNode("i", { class: "fa fa-circle-play" }, null, -1)
                                ]), 8, _hoisted_78)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                              : _withDirectives((_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  disabled: trader.isBlocked,
                                  title: _ctx.helper.trans('labels.traffic_blocked'),
                                  onClick: _withModifiers(($event: any) => (_ctx.toggleTraffic(trader, _ctx.Direction.PAY_OUT, true)), ["prevent"]),
                                  class: "ms-2 btn btn-sm btn-outline-warning"
                                }, _cache[58] || (_cache[58] = [
                                  _createElementVNode("i", { class: "fa fa-circle-pause" }, null, -1)
                                ]), 8, _hoisted_79)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_80, [
                            (trader.isPayOutTrafficBlocked)
                              ? _withDirectives((_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  title: _ctx.helper.trans('labels.traffic_blocked'),
                                  class: "fa fa-circle-pause text-warning"
                                }, null, 8, _hoisted_81)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                              : _withDirectives((_openBlock(), _createElementBlock("i", {
                                  key: 1,
                                  title: _ctx.helper.trans('trader.status.active'),
                                  class: "fa fa-circle-play text-success"
                                }, null, 8, _hoisted_82)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ])
                          ]))
                    ]),
                    (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_83, _toDisplayString(trader.id), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_84, [
                        _createVNode(_component_UserNameLabel, { user: trader }, null, 8, ["user"])
                      ]),
                      (_ctx.isAdmin && trader.blockReason)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_85, [
                            _cache[59] || (_cache[59] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans(`block_reason.${trader.blockReason}`)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      ((_ctx.isAdmin || _ctx.isOperator) && trader.isAlfaCardsEnabled)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            _createElementVNode("small", _hoisted_87, [
                              _cache[60] || (_cache[60] = _createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("labels.is_alfa_cards_enabled")), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.deviceSumCheckDisablingEnabled && (_ctx.isAdmin || _ctx.isOperator) && trader.isDeviceSumCheckDisabled)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                            _createElementVNode("small", _hoisted_89, [
                              _cache[61] || (_cache[61] = _createElementVNode("i", { class: "fa fa-info-circle" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.helper.trans("labels.is_device_sum_check_disabled")), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      ((_ctx.isAdmin || _ctx.isOperator) && trader.comment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                            _createElementVNode("small", _hoisted_91, [
                              _cache[62] || (_cache[62] = _createElementVNode("i", { class: "fa fa-comment" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(trader.comment), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.isAdmin || _ctx.isOperator)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_92, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trader.teamLeads, (teamLead, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              teamLead
                                ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                    _createVNode(_component_UserNameLabel, { user: teamLead }, null, 8, ["user"]),
                                    _cache[63] || (_cache[63] = _createTextVNode()),
                                    (trader.hiddenTeamLeads.includes(teamLead?.id))
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_94))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trader._accounts, (account) => {
                        return (_openBlock(), _createElementBlock("div", null, [
                          _createElementVNode("div", _hoisted_95, [
                            _createElementVNode("div", _hoisted_96, [
                              _createVNode(_component_AccountWidget, { account: account }, null, 8, ["account"]),
                              _createElementVNode("div", _hoisted_97, [
                                (_ctx.isAdmin || _ctx.isOperator)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                      _withDirectives((_openBlock(), _createElementBlock("small", {
                                        title: account.id
                                      }, [
                                        _createTextVNode(_toDisplayString(account.id.substring(0, 8)), 1)
                                      ], 8, _hoisted_99)), [
                                        [
                                          _directive_b_tooltip,
                                          void 0,
                                          void 0,
                                          { hover: true }
                                        ]
                                      ]),
                                      _cache[64] || (_cache[64] = _createTextVNode()),
                                      _createVNode(_component_copy_button, {
                                        value: account.id
                                      }, null, 8, ["value"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isAdmin || _ctx.isOperator)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      onClick: ($event: any) => (_ctx.$refs.accountOperationsModal.showModal(account)),
                                      class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize-first"
                                    }, _toDisplayString(_ctx.helper.trans("menu.items.accountOperations")), 9, _hoisted_100))
                                  : _createCommentVNode("", true),
                                (_ctx.isAdmin || _ctx.isOperator)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.showAccountWalletModal(account)),
                                      class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize ms-2"
                                    }, _cache[65] || (_cache[65] = [
                                      _createElementVNode("i", { class: "fa fa-wallet" }, null, -1)
                                    ]), 8, _hoisted_101))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                      }), 256))
                    ]),
                    _createElementVNode("td", _hoisted_102, [
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.showEditModal(trader)),
                              class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                            }, [
                              _cache[66] || (_cache[66] = _createElementVNode("i", { class: "fa fa-pencil" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.edit')), 1)
                            ], 8, _hoisted_104),
                            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_105, _cache[67] || (_cache[67] = [
                              _createElementVNode("span", { class: "visually-hidden" }, "Toggle Dropdown", -1)
                            ]))), [
                              [_directive_bs_dropdown_fixed]
                            ]),
                            _createElementVNode("ul", _hoisted_106, [
                              (!trader.isBlocked)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_107, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (_ctx.showBlockReason(trader)), ["prevent"])
                                    }, [
                                      _cache[68] || (_cache[68] = _createElementVNode("i", { class: "fa fa-ban" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.block')), 1)
                                    ], 8, _hoisted_108)
                                  ]))
                                : (_openBlock(), _createElementBlock("li", _hoisted_109, [
                                    _createElementVNode("a", {
                                      class: _normalizeClass(["dropdown-item", {disabled: !_ctx.store.getters.hasPermission(_ctx.UserPermission.UNBLOCK_TRADERS)}]),
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (_ctx.unblockTrader(trader)), ["prevent"])
                                    }, [
                                      _cache[69] || (_cache[69] = _createElementVNode("i", { class: "fa-regular fa-circle-check" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.unblock')), 1)
                                    ], 10, _hoisted_110)
                                  ])),
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  href: "#",
                                  onClick: _withModifiers(($event: any) => (_ctx.showPayoutSettings(trader.id)), ["prevent"])
                                }, [
                                  _cache[70] || (_cache[70] = _createElementVNode("i", { class: "fa fa-gear" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.payout_settings')), 1)
                                ], 8, _hoisted_111)
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  href: "#",
                                  onClick: _withModifiers(($event: any) => (_ctx.showTraderHistory(trader)), ["prevent"])
                                }, [
                                  _cache[71] || (_cache[71] = _createElementVNode("i", { class: "fa fa-clock-rotate-left" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.history')), 1)
                                ], 8, _hoisted_112)
                              ]),
                              (_ctx.store.getters.hasPermission(_ctx.UserPermission.VIEW_USER_SESSION_HISTORY))
                                ? (_openBlock(), _createElementBlock("li", _hoisted_113, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (_ctx.downloadSessionHistory(trader.id)), ["prevent"])
                                    }, [
                                      _cache[72] || (_cache[72] = _createElementVNode("i", { class: "fa fa-file-download" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.download_session_history')), 1)
                                    ], 8, _hoisted_114)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isOperator)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                            (_ctx.store.getters.hasPermission(_ctx.UserPermission.BLOCK_TRADERS) && !trader.isBlocked)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.showBlockReason(trader)),
                                  class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                                }, [
                                  _cache[73] || (_cache[73] = _createElementVNode("i", { class: "fa fa-ban" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.block')), 1)
                                ], 8, _hoisted_116))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _withModifiers(($event: any) => (_ctx.showTraderHistory(trader)), ["prevent"]),
                              class: "ms-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                            }, [
                              _cache[74] || (_cache[74] = _createElementVNode("i", { class: "fa fa-clock-rotate-left" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.history')), 1)
                            ], 8, _hoisted_117),
                            (_ctx.store.getters.hasPermission(_ctx.UserPermission.RESET_TRADER_PASSWORD))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  onClick: _withModifiers(($event: any) => (_ctx.showChangePasswordModal(trader)), ["prevent"]),
                                  class: "ms-2 btn btn-sm btn-outline-secondary text-nowrap text-capitalize"
                                }, [
                                  _cache[75] || (_cache[75] = _createElementVNode("i", { class: "fa fa-key" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.change_password')), 1)
                                ], 8, _hoisted_118))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      ((_ctx.isAdmin || _ctx.isTeamLead) || (_ctx.isOperator && !_ctx.store.getters.hasPermission(_ctx.UserPermission.HIDE_DEAL_RATES)))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            type: "button",
                            onClick: ($event: any) => (_ctx.showRouting(trader)),
                            class: "ms-2 btn btn-sm btn-outline-dark text-nowrap text-capitalize"
                          }, [
                            _cache[76] || (_cache[76] = _createElementVNode("i", { class: "fa fa-percent" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.percent_rates')) + " ", 1),
                            (_ctx.isTeamLead && trader.mainTeamLead?.id !== _ctx.user?.id)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_120))
                              : _createCommentVNode("", true),
                            (_ctx.isTeamLead && trader.mainTeamLead?.id === _ctx.user?.id)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_121))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_119))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.response.totalCount > _ctx.response.items.length)
              ? (_openBlock(), _createBlock(_component_b_pagination, {
                  key: 0,
                  modelValue: _ctx.page,
                  "onUpdate:modelValue": [
                    _cache[22] || (_cache[22] = ($event: any) => ((_ctx.page) = $event)),
                    _cache[23] || (_cache[23] = ($event: any) => (_ctx.loadList()))
                  ],
                  "total-rows": _ctx.response.totalCount,
                  "per-page": _ctx.response.limit,
                  limit: 20,
                  "prev-text": "Back",
                  "next-text": "Next",
                  align: "start",
                  "first-number": "",
                  "hide-goto-end-buttons": "",
                  "hide-ellipsis": ""
                }, null, 8, ["modelValue", "total-rows", "per-page"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(_component_InviteLinkConfirmModal, { ref: "inviteLinkConfirmModal" }, null, 512),
      _createVNode(_component_b_modal, {
        title: _ctx.helper.trans('labels.transfer'),
        modelValue: _ctx.transferAccount !== null,
        "header-class": "text-capitalize",
        "body-class": "pt-0",
        "footer-class": "d-flex justify-content-between",
        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ($event === false && (_ctx.transferAccount = null)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TransferForm, {
            ref: "transferForm",
            account: _ctx.transferAccount
          }, null, 8, ["account"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.transferAccount = null)),
            class: "btn btn-outline-dark btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans("button.cancel")), 1),
          _createVNode(_component_LoaderWrapper, {
            ref: "loaderTransferForm",
            zoom: 0.5
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.createTransfer())),
                class: "btn btn-outline-primary btn-sm text-capitalize-first"
              }, _toDisplayString(_ctx.helper.trans("button.transfer")), 1)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_b_modal, {
        title: _ctx.helper.trans('labels.import_traders_percent_rates'),
        modelValue: _ctx.ratesImportModal !== null,
        "header-class": "text-capitalize",
        "body-class": "pt-0",
        "footer-class": "d-flex justify-content-between",
        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ($event === false && (_ctx.ratesImportModal = null)))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_122, [
            _createElementVNode("div", _hoisted_123, [
              _createElementVNode("div", _mergeProps({ style: {"cursor":"pointer","border":"1px dashed"} }, _ctx.dropzone.getRootProps(), { class: "payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center" }), [
                _createElementVNode("input", _normalizeProps(_guardReactiveProps(_ctx.dropzone.getInputProps())), null, 16),
                _createElementVNode("p", _hoisted_124, _toDisplayString(_ctx.helper.trans('labels.payout_upload_files')), 1)
              ], 16)
            ])
          ]),
          (_ctx.importFile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                _createElementVNode("div", _hoisted_126, [
                  _cache[78] || (_cache[78] = _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)),
                  _cache[79] || (_cache[79] = _createTextVNode()),
                  _createElementVNode("span", _hoisted_127, _toDisplayString(_ctx.importFile.name), 1),
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.importFile = null), ["prevent"]))
                  }, _cache[77] || (_cache[77] = [
                    _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                  ]))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.ratesImportModal = null)),
            class: "btn btn-outline-dark btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans("button.cancel")), 1),
          _createVNode(_component_LoaderWrapper, {
            ref: "loaderRatesImportModal",
            zoom: 0.5
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.importTraderRates(_ctx.user?.id))),
                class: "btn btn-outline-primary btn-sm text-capitalize-first"
              }, _toDisplayString(_ctx.helper.trans("labels.import")), 1)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_b_modal, {
        "dialog-class": "modal-xxl",
        title: `${_ctx.routingTrader?.name}`,
        modelValue: _ctx.routingTrader !== null,
        "body-class": "pt-0",
        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ($event === false && (_ctx.routingTrader = null)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TraderRewardSettingsForm, {
            ref: "traderRewardSettingsForm",
            trader: _ctx.routingTrader
          }, null, 8, ["trader"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.routingTrader = null)),
            class: "btn btn-outline-secondary btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
          (_ctx.isAdmin || _ctx.isOperator || (_ctx.isTeamLead && _ctx.routingTrader?.mainTeamLead?.id === _ctx.user?.id))
            ? (_openBlock(), _createBlock(_component_LoaderWrapper, {
                key: 0,
                ref: "loaderRoutingRule",
                zoom: 0.5
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.saveRoutingRule())),
                    class: "btn btn-outline-primary btn-sm text-capitalize-first"
                  }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_b_modal, {
        title: `${_ctx.blockingTrader?.name}`,
        modelValue: _ctx.blockingTrader !== null,
        "header-class": "text-capitalize",
        "body-class": "pt-0",
        "footer-class": "d-flex justify-content-between",
        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ($event === false && (_ctx.blockingTrader = null)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Multiselect, {
            class: "mt-3",
            modelValue: _ctx.blockReason,
            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.blockReason) = $event)),
            options: Object.values(_ctx.BlockReason),
            "custom-label": (opt) => _ctx.helper.trans(`block_reason.${opt}`),
            "select-label": "Select",
            placeholder: _ctx.helper.trans('block_reason.label'),
            "open-direction": "bottom",
            multiple: false,
            searchable: false,
            "close-on-select": true,
            "show-no-results": false
          }, null, 8, ["modelValue", "options", "custom-label", "placeholder"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[35] || (_cache[35] = ($event: any) => {_ctx.blockingTrader = null; _ctx.blockReason = null}),
            class: "btn btn-outline-dark btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans("button.cancel")), 1),
          _createVNode(_component_LoaderWrapper, {
            ref: "loaderBlockReasonModal",
            zoom: 0.5
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.saveBlockReason())),
                disabled: !_ctx.blockReason,
                class: "btn btn-outline-primary btn-sm text-capitalize-first"
              }, _toDisplayString(_ctx.helper.trans('button.block')), 9, _hoisted_128)
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["title", "modelValue"]),
      _createVNode(_component_b_modal, {
        title: "",
        "dialog-class": "modal-lg",
        modelValue: _ctx.payOutSettingsModal,
        "footer-class": "d-flex justify-content-end",
        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.payOutSettingsModal = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LoaderWrapper, { ref: "payOutSettingsModalLoader" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_129, [
                _createElementVNode("div", _hoisted_130, [
                  _createElementVNode("div", _hoisted_131, [
                    _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.helper.trans("labels.from_sum")), 1),
                    _createElementVNode("div", _hoisted_133, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.getErrors(`minAmount`)
                      }, {
                        default: _withCtx((parentProps) => [
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass([parentProps.class, "form-control"]),
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.payOutSettings.minAmount) = $event)),
                            type: "text",
                            id: "from_sum",
                            readonly: !_ctx.isAdmin
                          }, null, 10, _hoisted_134), [
                            [_vModelText, _ctx.payOutSettings.minAmount]
                          ])
                        ]),
                        _: 1
                      }, 8, ["errors"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_135, [
                    _createElementVNode("label", _hoisted_136, _toDisplayString(_ctx.helper.trans("labels.to_sum")), 1),
                    _createElementVNode("div", _hoisted_137, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.getErrors(`maxAmount`)
                      }, {
                        default: _withCtx((parentProps) => [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.payOutSettings.maxAmount) = $event)),
                            class: _normalizeClass([parentProps.class, "form-control"]),
                            type: "text",
                            id: "to_sum",
                            readonly: !_ctx.isAdmin
                          }, null, 10, _hoisted_138), [
                            [_vModelText, _ctx.payOutSettings.maxAmount]
                          ])
                        ]),
                        _: 1
                      }, 8, ["errors"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_139, [
                    _createElementVNode("label", _hoisted_140, _toDisplayString(_ctx.helper.trans("labels.currencies")), 1),
                    _createElementVNode("div", _hoisted_141, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.getErrors(`appId`)
                      }, {
                        default: _withCtx((parentProps) => [
                          _createVNode(_component_Multiselect, {
                            id: "pay-out-currencies",
                            class: "multiselect-sm",
                            modelValue: _ctx.payOutSettings.currencies,
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.payOutSettings.currencies) = $event)),
                            options: _ctx.currencyList,
                            "custom-label": (opt) => `${opt}`,
                            multiple: true,
                            "select-label": "Select",
                            disabled: !_ctx.isAdmin
                          }, null, 8, ["modelValue", "options", "custom-label", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["errors"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_142, [
                    _createElementVNode("label", _hoisted_143, _toDisplayString(_ctx.helper.trans('labels.rounded_to_1000')), 1),
                    _createElementVNode("div", _hoisted_144, [
                      _createElementVNode("div", _hoisted_145, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          disabled: !_ctx.isAdmin,
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.payOutSettings.multiplesOfValue1000) = $event)),
                          type: "checkbox",
                          id: "pay-out-roundedToTakerSum"
                        }, null, 8, _hoisted_146), [
                          [_vModelCheckbox, _ctx.payOutSettings.multiplesOfValue1000]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_147, [
                    _createElementVNode("label", _hoisted_148, _toDisplayString(_ctx.helper.trans("labels.payment_methods")), 1),
                    _createElementVNode("div", _hoisted_149, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.getErrors(`payment_methods`)
                      }, {
                        default: _withCtx((parentProps) => [
                          _createVNode(_component_Multiselect, {
                            id: "pay-out-methods",
                            class: "multiselect-sm",
                            modelValue: _ctx.payOutSettings.paymentMethods,
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.payOutSettings.paymentMethods) = $event)),
                            options: _ctx.methodList(),
                            "custom-label": (opt) => _ctx.helper.trans(`pay_methods.${opt}`),
                            multiple: true,
                            "select-label": "Select",
                            disabled: !_ctx.isAdmin
                          }, {
                            option: _withCtx((props) => [
                              _createElementVNode("div", _hoisted_150, [
                                _createVNode(_component_PayMethodIcon, {
                                  "icon-class": "icon",
                                  method: props.option
                                }, null, 8, ["method"]),
                                _createElementVNode("span", _hoisted_151, _toDisplayString(_ctx.helper.trans('pay_methods.' + props.option)), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "options", "custom-label", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["errors"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_152, [
                    _createElementVNode("label", _hoisted_153, _toDisplayString(_ctx.helper.trans("labels.payment_options")), 1),
                    _createElementVNode("div", _hoisted_154, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.getErrors(`payment_options`)
                      }, {
                        default: _withCtx((parentProps) => [
                          _createVNode(_component_Multiselect, {
                            id: "pay-out-options",
                            class: "multiselect-sm",
                            modelValue: _ctx.payOutSettings.paymentOptions,
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.payOutSettings.paymentOptions) = $event)),
                            options: _ctx.store.getters['currencyMethods/options'](),
                            "custom-label": (opt) => _ctx.helper.trans(`payment_options.${opt}`),
                            multiple: true,
                            "select-label": "Select",
                            disabled: !_ctx.isAdmin
                          }, null, 8, ["modelValue", "options", "custom-label", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["errors"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_155, [
                    _createElementVNode("label", _hoisted_156, _toDisplayString(_ctx.helper.trans("labels.only_mir_cards")), 1),
                    _createElementVNode("div", _hoisted_157, [
                      _createElementVNode("div", _hoisted_158, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.payOutSettings.onlyMir) = $event)),
                          "true-value": true,
                          type: "checkbox",
                          value: "",
                          id: "pay-out-onlyMir",
                          disabled: !_ctx.isAdmin
                        }, null, 8, _hoisted_159), [
                          [_vModelCheckbox, _ctx.payOutSettings.onlyMir]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_160, [
                    _createElementVNode("label", _hoisted_161, _toDisplayString(_ctx.helper.trans("labels.max_active_deals_count")), 1),
                    _createElementVNode("div", _hoisted_162, [
                      _createElementVNode("div", _hoisted_163, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-sm",
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.payOutSettings.maxActiveDealsCount) = $event)),
                          readonly: !_ctx.isAdmin,
                          id: "maxActiveDealCount"
                        }, null, 8, _hoisted_164), [
                          [_vModelText, _ctx.payOutSettings.maxActiveDealsCount]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_165, [
                    _createElementVNode("label", _hoisted_166, _toDisplayString(_ctx.helper.trans("labels.limitAmount")), 1),
                    _createElementVNode("div", _hoisted_167, [
                      _createElementVNode("div", _hoisted_168, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-sm",
                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.payOutSettings.limitAmount) = $event)),
                          readonly: !_ctx.isAdmin,
                          id: "limitAmount"
                        }, null, 8, _hoisted_169), [
                          [_vModelText, _ctx.payOutSettings.limitAmount]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_170, [
                    _createElementVNode("label", _hoisted_171, _toDisplayString(_ctx.helper.trans("labels.limitIntervalMinutes")), 1),
                    _createElementVNode("div", _hoisted_172, [
                      _createElementVNode("div", _hoisted_173, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-sm",
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.payOutSettings.limitIntervalMinutes) = $event)),
                          readonly: !_ctx.isAdmin,
                          id: "limitIntervalMinutes"
                        }, null, 8, _hoisted_174), [
                          [_vModelText, _ctx.payOutSettings.limitIntervalMinutes]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_175, [
                    _createElementVNode("label", _hoisted_176, _toDisplayString(_ctx.helper.trans('labels.auto_accept_payouts')), 1),
                    _createElementVNode("div", _hoisted_177, [
                      _createElementVNode("div", _hoisted_178, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          disabled: !_ctx.isAdmin,
                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.payOutSettings.autoAccept) = $event)),
                          type: "checkbox",
                          id: "auto_accept_payouts"
                        }, null, 8, _hoisted_179), [
                          [_vModelCheckbox, _ctx.payOutSettings.autoAccept]
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.isAdmin || (_ctx.isOperator && _ctx.payOutSettings.isPayinBalanceLimitActive))
                    ? (_openBlock(), _createElementBlock("hr", _hoisted_180))
                    : _createCommentVNode("", true),
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createBlock(_component_PayinBalanceLimitSection, {
                        key: 1,
                        settings: _ctx.payOutSettings,
                        "show-admin-controls": "",
                        "can-edit": _ctx.isAdmin,
                        "can-reset": _ctx.canResetPayinBalance,
                        onReset: _ctx.resetPayinBalance
                      }, null, 8, ["settings", "can-edit", "can-reset", "onReset"]))
                    : (_ctx.isOperator && _ctx.payOutSettings.isPayinBalanceLimitActive)
                      ? (_openBlock(), _createBlock(_component_PayinBalanceLimitSection, {
                          key: 2,
                          settings: _ctx.payOutSettings
                        }, null, 8, ["settings"]))
                      : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 512)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[49] || (_cache[49] = _withModifiers(($event: any) => (_ctx.payOutSettingsModal = false), ["prevent"])),
            class: "btn btn-outline-secondary btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
          _createElementVNode("button", {
            disabled: !_ctx.isAdmin,
            type: "button",
            onClick: _cache[50] || (_cache[50] = _withModifiers(($event: any) => (_ctx.savePayoutSettings(_ctx.payOutSettings.traderId)), ["prevent"])),
            class: "btn btn-outline-primary btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.save')), 9, _hoisted_181)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_AccountOperationsModal, { ref: "accountOperationsModal" }, null, 512),
      _createVNode(_component_AccountWalletModal, { ref: "accountWalletModal" }, null, 512),
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512),
      _createVNode(_component_ChangePasswordModal, { ref: "changePasswordModal" }, null, 512),
      _createVNode(_component_SettingsHistoryModal, {
        ref: "traderHistoryModal",
        "entity-type": "trader"
      }, null, 512)
    ]),
    _: 1
  }, 512))
}